
import Vue from 'vue'
import Card from '~/components/atoms/Card.vue'

export default Vue.extend({
  components: {
    Card,
  },
  data() {
    return {
      check: true,
    }
  },
  mounted() {
    this.setContentHeight()
  },
  methods: {
    onToggle() {
      if (this.$data.check) {
        this.setContentHeight()
      } else {
        this.clearContentHeight()
      }
    },
    setContentHeight() {
      const innerDom = this.$refs.contentInner as HTMLDivElement
      const contentDom = this.$refs.content as HTMLDivElement
      contentDom.style.maxHeight = `${innerDom.getBoundingClientRect().height}px`
    },
    clearContentHeight() {
      const contentDom = this.$refs.content as HTMLDivElement
      contentDom.style.maxHeight = '0'
    },
  },
})
